import React, { useEffect, useState } from "react";
import api from "@/lib/apiClient";
import { AdminHeader, AdminPage, StateBadge } from "@/components/admin/AdminUI";

export default function Enquiries() {
  const [items, setItems] = useState([]);
  const [sel, setSel] = useState(null);
  const load = () => api.get("/contact").then(({ data }) => setItems(data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const open = async (e) => { setSel(e); if (e.status === "new") { await api.patch(`/contact/${e.id}`, { status: "read" }); load(); } };

  return (
    <>
      <AdminHeader title="Contact Enquiries" subtitle={`${items.length} enquiries`} />
      <AdminPage>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="lg:col-span-1 bg-white border border-slate-200 rounded-lg overflow-hidden max-h-[75vh] overflow-y-auto">
            {items.length === 0 ? <p className="p-6 text-sm text-slate-400">No enquiries yet.</p> : items.map((e) => (
              <button key={e.id} onClick={() => open(e)} className={`w-full text-left px-4 py-3 border-b border-slate-100 hover:bg-slate-50 ${sel?.id === e.id ? "bg-npst-goldLight/50" : ""}`} data-testid={`enquiry-${e.id}`}>
                <div className="flex items-center justify-between"><span className="font-medium text-sm text-npst-ink truncate">{e.name}</span><StateBadge state={e.status} /></div>
                <div className="text-xs text-slate-500 truncate">{e.subject}</div>
                <div className="text-[10px] text-slate-400 mt-1">{e.category} · {e.created_at?.slice(0, 10)}</div>
              </button>
            ))}
          </div>
          <div className="lg:col-span-2 bg-white border border-slate-200 rounded-lg p-6">
            {!sel ? <p className="text-slate-400 text-sm">Select an enquiry to view details.</p> : (
              <div className="space-y-4">
                <h2 className="font-serif text-2xl text-npst-ink">{sel.subject}</h2>
                <div className="grid grid-cols-2 gap-3 text-sm">
                  <div><span className="label-eyebrow text-slate-400 block">Name</span>{sel.name}</div>
                  <div><span className="label-eyebrow text-slate-400 block">Email</span>{sel.email}</div>
                  <div><span className="label-eyebrow text-slate-400 block">Phone</span>{sel.phone || "—"}</div>
                  <div><span className="label-eyebrow text-slate-400 block">Category</span>{sel.category}</div>
                </div>
                <div><span className="label-eyebrow text-slate-400 block mb-1">Message</span><p className="text-npst-inkSoft leading-relaxed whitespace-pre-wrap">{sel.message}</p></div>
                <a href={`mailto:${sel.email}?subject=Re: ${encodeURIComponent(sel.subject)}`} className="inline-block text-sm text-npst-navy font-semibold hover:text-npst-gold">Reply via email →</a>
              </div>
            )}
          </div>
        </div>
      </AdminPage>
    </>
  );
}
